import { render, staticRenderFns } from "./TemplateScheduling.vue?vue&type=template&id=c1bf1620&scoped=true&"
import script from "./TemplateScheduling.vue?vue&type=script&lang=ts&"
export * from "./TemplateScheduling.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1bf1620",
  null
  
)

export default component.exports